// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Loader_wrapper__2ASoL","box":"Loader_box__2ADZ0"};